module.exports = __webpack_public_path__ + "img/qritem2.ddfb9e40.png";